export const isHTMLElement = (value) => {
  try {
    if (!window || !document) {
      return false;
    }
    return value instanceof Element || value instanceof Document;
  } catch {
    return false;
  }
};

export default isHTMLElement;
